import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 retrieve_tenant_agencies: { message: "idle" },
};

export const retrieve_tenant_agencies_Slice = createSlice({
 name: "retrieve_tenant_agencies",
 initialState,
 reducers: {
  success_retrieve_tenant_agencies: (state, action) => {
   state.retrieve_tenant_agencies = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_retrieve_tenant_agencies: (state, action) => {
   state.retrieve_tenant_agencies = { status: app_consts.FAIL, message: action.payload };
  },
  reset_retrieve_tenant_agencies: (state) => {
   state.retrieve_tenant_agencies = { status: app_consts.IDLE };
  },
  loading_retrieve_tenant_agencies: (state) => {
   state.retrieve_tenant_agencies = { status: app_consts.LOADING };
  },
 }
});

export const { success_retrieve_tenant_agencies, fail_retrieve_tenant_agencies, reset_retrieve_tenant_agencies, loading_retrieve_tenant_agencies } = retrieve_tenant_agencies_Slice.actions;

export default retrieve_tenant_agencies_Slice.reducer;